import APP_URL from 'utils/helperConfig'

export const sepaBankTranfer = ({ type, fromAsset, amount }) => ({
    type,
    amount: {
        currencyCode: fromAsset,
        value: Number(amount),
    },
})

export const parseBankAccountWithCurrency = ({ value, currencyCode, accountNumber }) => ({
    amount: {
        currencyCode,
        value: +value,
    },
    accountNumber,
})

export const companyPaymentWithNoCardData = ({ amount, currencyCode }) => ({
    amount: {
        currencyCode,
        value: amount,
    },
    redirectUrl: `${APP_URL}/company-card-payment`,
})

export const companyPaymentWithOnlineBanking = ({ amount, currencyCode }) => ({
    amount: {
        currencyCode,
        value: amount,
    },
    redirectUrl: `${APP_URL}/company-online-bank-payment`,
})

export const ledgerTopUpWithNoCardData = ({ amount, currencyCode }) => ({
    amount: {
        currencyCode,
        value: amount,
    },
    redirectUrl: `${APP_URL}/card-deposit`,
})

export const ledgerTopUpWithOnlineBanking = ({ amount, currencyCode }) => ({
    amount: {
        currencyCode,
        value: amount,
    },
    redirectUrl: `${APP_URL}/bank-deposit`,
})

export const feeCalculator = ({ amount, fromAsset, toAsset, service }) => ({
    amount: {
        currencyCode: fromAsset,
        value: amount,
    },
    service,
    exchangeCurrencyCode: toAsset,
})

export const mergedFeeCalculator = ({ sourceAccountId, targetAccountId, transferIntent, currencyCode, amount }) => ({
    sourceAccountId,
    targetAccountId,
    transferIntent,
    amount: {
        currencyCode,
        value: amount,
    },
})

export const passwordReset = ({ passwordResetRequestId, newPassword }) => ({
    passwordResetRequestId,
    newPassword,
})

export const emailTransferForPasswordReset = ({ email }) => ({
    email,
})

export const orderNewLedger = ({ currencyCode }) => ({
    currencyCode,
})

export const transferToBank = ({
    transferType,
    amount,
    currencyCode,
    name,
    account,
    address,
    city,
    country,
    bic,
    bankName,
    bankAddress,
    bankCity,
    bankCountry,
    postCode,
    bankPostCode,
    paymentReference,
    verificationCode,
    label,
    templateNo,
    save,
}) => {
    const types = transferType === 'Sepa' ? 'Sepa' : 'International'

    return {
        amount: {
            currencyCode,
            value: amount,
        },
        type: types,
        payslip: {
            beneficiary: {
                name,
                accountNumber: account,
                address: {
                    address,
                    city,
                    postCode,
                    countryCode: country,
                },
            },
            bank: {
                name: bankName,
                bic,
                address: {
                    address: bankAddress,
                    city: bankCity,
                    postCode: bankPostCode,
                    countryCode: bankCountry,
                },
            },
            paymentReference,
        },
        verificationCode,
        beneficiary: {
            label,
            templateNo,
            save,
        },
    }
}

export const patchMoveOp = (identifier, sectionIndex, favSectionIdx, favAssetIdx) => [
    {
        value: {
            identifier,
        },
        from: `/sections/${favSectionIdx}/assets/${favAssetIdx}`,
        path: `/sections/${sectionIndex}/assets/0`,
        op: 'move',
    },
]

export const patchAddOp = (identifier, sectionIndex) => [
    {
        value: {
            identifier,
        },
        path: `/sections/${sectionIndex}/assets/0`,
        op: 'add',
    },
]

export const patchRemoveOp = (favSectionIdx, favAssetIdx) => [
    {
        path: `/sections/${favSectionIdx}/assets/${favAssetIdx}`,
        op: 'remove',
    },
]

export const postUserSignUp = ({
    firstName,
    lastName,
    email,
    password,
    languageCode,
    referral,
    referer,
    metadata,
    browserUniqueId,
    browser,
    affiliate,
    referrerKeyword,
    recaptcha,
    reCaptchaVersion,
    utmSource,
    utmCampaign,
    utmMedium,
}) => ({
    currencyCode: 'EUR',
    device: {
        id: browserUniqueId,
        name: browser,
        type: 'Web',
    },
    email,
    firstName,
    isAgreementConfirmed: true,
    lastName,
    password,
    referredBy: referral,
    referer,
    metadata,
    affiliatedBy: affiliate,
    referrerKeyword,
    languageCode,
    recaptcha,
    reCaptchaVersion,
    utmCampaign,
    utmMedium,
    utmSource,
})

export const sendDigitalAsset = ({ amount, address, verificationCode, tag, label, templateNo, save, blockchainNetwork }) => ({
    blockchainNetwork,
    amount,
    address,
    verificationCode,
    tag,
    beneficiary: {
        label,
        templateNo,
        save,
    },
})

export const digitalAssetsUsdcWithdraw = ({
    amount,
    name,
    account,
    address,
    city,
    country,
    bic,
    bankName,
    bankAddress,
    bankCity,
    bankCountry,
    postCode,
    bankPostCode,
    paymentReference,
    verificationCode,
    districtCode,
}) => ({
    amount,
    bankPayslip: {
        reference: paymentReference,
        beneficiary: {
            name,
            accountNumber: account,
            address: {
                address,
                city,
                postCode,
                countryCode: country,
            },
        },
        bank: {
            name: bankName,
            bic,
            internationalBic: '',
            address: {
                address: bankAddress,
                city: bankCity,
                postCode: bankPostCode,
                countryCode: bankCountry,
            },
        },
        type: 'Sepa',
    },
    districtCode,
    verificationCode,
})

export const postSignIn = ({ email, password, browserUniqueId, browser, recaptcha, reCaptchaVersion }) => ({
    device: {
        id: browserUniqueId,
        name: browser,
        type: 'Web',
    },
    email,
    password,
    recaptcha,
    reCaptchaVersion,
})

export const postBusinessRegistration = ({
    companyName,
    payerNumber,
    city,
    countryCode,
    postCode,
    street,
    isRepresentative,
    currencyCode,
}) => ({
    companyName,
    payerNumber,
    city,
    countryCode,
    postCode,
    street,
    isRepresentative,
    currencyCode,
})

export const postBusinessRegistrationSignUp = ({
    firstName,
    lastName,
    email,
    password,
    referral,
    languageCode,
    companyName,
    companyNumber,
    countryCode,
    companyPhone,
    isCheckBoxChecked,
    affiliate,
    metadata,
    referer,
    browserUniqueId,
    browser,
    recaptcha,
    reCaptchaVersion,
    utmCampaign,
    utmMedium,
    utmSource,
}) => ({
    userDetails: {
        firstName,
        lastName,
        email,
        password,
    },
    companyDetails: {
        legalName: companyName,
        registrationNumber: companyNumber,
        phoneNumber: companyPhone,
        countryCode,
    },
    device: {
        id: browserUniqueId,
        name: browser,
        type: 'Web',
    },
    currencyCode: 'EUR',
    appType: 'Web',
    isAgreementConfirmed: isCheckBoxChecked,
    referer,
    languageCode,
    affiliatedBy: affiliate,
    metadata,
    referredBy: referral,
    recaptcha,
    reCaptchaVersion,
    utmCampaign,
    utmMedium,
    utmSource,
})

export const postBusinessRegistrationForm = ({
    companyName,
    city,
    country,
    address,
    postCode,
    payerNumber,
    verificationCode,
    website,
    email,
    phone,
    data,
    formVersion,
}) => ({
    companyName,
    city,
    country,
    address,
    postCode,
    payerNumber,
    verificationCode,
    website,
    email,
    phone,
    data,
    formVersion,
})

export const digitalAssetsBuyUsdcWithBank = ({
    amount,
    name,
    account,
    address,
    city,
    country,
    bic,
    bankName,
    bankAddress,
    bankCity,
    bankCountry,
    postCode,
    bankPostCode,
    paymentReference,
    districtCode,
}) => ({
    amount,
    bankPayslip: {
        beneficiary: {
            name,
            accountNumber: account,
            address: {
                address,
                city,
                postCode,
                countryCode: country,
            },
        },
        bank: {
            name: bankName,
            bic,
            address: {
                address: bankAddress,
                city: bankCity,
                postCode: bankPostCode,
                countryCode: bankCountry,
            },
        },
        paymentReference,
    },
    districtCode,
})

export const parseBankInternalTransfer = ({ accountNumber, amount, currencyCode, paymentReference, verificationCode }) => ({
    accountNumber,
    amount: {
        currencyCode,
        value: amount,
    },
    paymentReference,
    verificationCode,
})

export const accountExchangeFee = ({ exchangeType, targetAccountId, amount, price }) => ({
    exchangeType,
    targetAccountId,
    amount,
    price,
})
